import { useGetUser } from 'entities/user/api';

/**
 * Hook to get the current board ID from the user's last board.
 *
 * @deprecated use hook from `entities/user/api/hooks/useGetCurrentBoardId` instead.
 * @returns {string | undefined} The ID of the last board the user accessed, or undefined if not available.
 */
export const useGetCurrentBoardId = () => {
  const { data } = useGetUser();

  return data?.lastBoard.id;
};
